import {Box, Divider, Grid, Typography} from '@mui/material';
import {t} from 'i18next';

interface ProjectProfileViewDetailsProps {
  projectDescription: string;
  overseeingAttorneys: string;
  entityName: string;
  clientUniqueProjectId: string;
  overseeingAttorneysEmail: string;
  additionalContactInfo: string;
  internalProjectName: string;
}

const ProjectProfileViewDetails = ({
  projectDescription,
  entityName,
  clientUniqueProjectId,
  overseeingAttorneys,
  overseeingAttorneysEmail,
  additionalContactInfo,
  internalProjectName
}: ProjectProfileViewDetailsProps) => {
  return (
    <Box className="profile-view-content">
      <Box mt={2} mb={3}>
        <Typography className="typo-text subhead2_size" mb={1}>
          {t('clientDetailsPage.projectDrawer.description')}
        </Typography>

        <Typography className="typo-text body2_size mist-1400">
          {projectDescription}
        </Typography>
      </Box>

      <Divider className="project-profile-divider" />

      <Grid container spacing={2} mt={2} mb={4} className="entity-field">
        <Grid item xs={12} md={6}>
          <Typography className="typo-text subhead2_size" mb={1}>
            {t('clientDetailsPage.projectDrawer.entityName')}
          </Typography>

          <Typography className="typo-text body2_size mist-1400">
            {entityName}
          </Typography>
        </Grid>
      </Grid>
      <Grid container spacing={2} mt={2} mb={4}>
        <Grid item xs={12} md={6}>
          <Typography className="typo-text subhead2_size" mb={1}>
            {t('welcomeScreenSingleClient.InternalProjectName')}
          </Typography>

          <Typography className="typo-text body2_size mist-1400">
            {internalProjectName}
          </Typography>
        </Grid>
        <Grid item xs={12} md={6}>
          <Typography className="typo-text subhead2_size" mb={1}>
            {t('clientDetailsPage.projectDrawer.clientUniqueProjectProfileId')}
          </Typography>

          <Typography className="typo-text body2_size mist-1400">
            {clientUniqueProjectId}
          </Typography>
        </Grid>
      </Grid>

      <Divider className="project-profile-divider" />

      <Box>
        <Box mt={2}>
          <Typography className="typo-text subhead2_size" mb={1}>
            {t('clientDetailsPage.projectDrawer.overseingAttorney')}
          </Typography>
        </Box>

        <Box mt={2}>
          <Box>
            <Typography className="typo-text subhead4_size">
              {t('clientDetailsPage.projectDrawer.overseeingAttorneyNames')}{' '}
            </Typography>
          </Box>
          <Box>
            <Typography mt={2} className="typo-text body2_size mist-1400">
              {overseeingAttorneys}
            </Typography>
          </Box>
        </Box>

        <Box mt={2}>
          <Box>
            <Typography className="typo-text subhead4_size">
              {t('clientDetailsPage.projectDrawer.emailAddresses')}
            </Typography>
          </Box>
          <Box>
            <Typography mt={2} className="typo-text body2_size mist-1400">
              {overseeingAttorneysEmail}
            </Typography>
          </Box>
        </Box>
        <Box mt={2}>
          <Box>
            <Typography className="typo-text subhead4_size">
              {t(
                'clientDetailsPage.projectDrawer.additionalContactInformation'
              )}
            </Typography>
          </Box>
          <Box>
            <Typography mt={2} variant="caption" className="typo-text body2_size mist-1400">
              {additionalContactInfo}
            </Typography>
          </Box>
        </Box>
      </Box>
    </Box>
  );
};

export default ProjectProfileViewDetails;
